import React from 'react';
import * as S from './styles';

interface DashboardContentProps {
  children?: React.ReactNode;
}

const DashboardContent: React.FC<DashboardContentProps> = ({ children }) => {
  return (
    <S.DashboardContainer>
      <S.DashboardContent>
        {children || (
          <S.EmptyState>
            <p>Bem-vindo ao SmartEntrega</p>
            <p>Selecione uma opção no menu lateral para começar</p>
          </S.EmptyState>
        )}
      </S.DashboardContent>
    </S.DashboardContainer>
  );
};

export default DashboardContent;
